import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ArrowUpDashIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M24.7772 9.71156L15.9638 1.2144C15.751 0.962133 15.3708 0.927506 15.1147 1.13701C15.0862 1.16036 15.0598 1.18624 15.0361 1.2144L6.22278 9.71156C5.94097 9.96881 5.92428 10.4024 6.18549 10.68C6.31503 10.8176 6.49615 10.8969 6.68668 10.8994H10.8614V21.909C10.9406 22.3691 11.3185 22.7227 11.7891 22.7771H19.2109C19.582 22.7771 19.6747 22.3203 19.6747 21.909V10.8994H24.3134C24.6976 10.8944 25.005 10.5836 24.9999 10.2052C24.9975 10.0175 24.9169 9.83913 24.7772 9.71156Z"
        fill="currentColor"
      />
      <path
        d="M19.2108 24.1475H11.789C11.4048 24.1475 11.0932 24.4544 11.0932 24.8328C11.0932 25.2112 11.4048 25.5181 11.789 25.5181H19.2108C19.5951 25.5181 19.9066 25.2112 19.9066 24.8328C19.9066 24.4544 19.5952 24.1475 19.2108 24.1475Z"
        fill="currentColor"
      />
      <path
        d="M19.2108 26.8885H11.789C11.4048 26.8885 11.0932 27.1954 11.0932 27.5738C11.0932 27.9522 11.4048 28.2591 11.789 28.2591H19.2108C19.5951 28.2591 19.9066 27.9522 19.9066 27.5738C19.9066 27.1954 19.5952 26.8885 19.2108 26.8885Z"
        fill="currentColor"
      />
      <path
        d="M19.2108 29.6295H11.789C11.4048 29.6295 11.0932 29.9363 11.0932 30.3147C11.0932 30.6932 11.4048 31 11.789 31H19.2108C19.5951 31 19.9066 30.6932 19.9066 30.3147C19.9066 29.9363 19.5952 29.6295 19.2108 29.6295Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
